import { useContext } from 'react';

import WorkoutContext from '../context';
import { WorkoutContextType } from '../types';

const useWorkoutContext = () => useContext<WorkoutContextType>(WorkoutContext);

export default useWorkoutContext;
